import { BaseQuery } from '../types'

const defaultPagination: BaseQuery = Object.freeze({
  page: 0,
  page_size: 10,
})

export { defaultPagination }
